/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SettleTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {SettleTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const settleTransaction = (request: SettleTransactionRequest, options?: CashRequestOptions) => post<SettleTransactionRequest, SettleTransactionResponse>("/2.0/cash/settle-transaction", request, {...options, rejectOnError: true })